import { Injectable } from '@angular/core';
import { AngularWaitBarrier } from 'blocking-proxy/built/lib/angular_wait_barrier';
import { Http, URLSearchParams, Headers } from '@angular/http';
import 'rxjs/Rx';
import { URL_SERVICIOS } from '../../conf/url.servicios';
import { Router } from '@angular/router';
import { Filtro } from '../../conf/clases';
import { Detalle } from '../../conf/clases';
import { Consulta } from '../../conf/clases';
import { Venta } from '../../conf/clases';
class Item {
  id: number;
  value: string;
  description: string;
  counter: number;
  title: string;
}

@Injectable()
export class ConsultaService {


  datosExcel: any;
  obtieneDatosExcel(param: Filtro): any {
    if (this.esNuevaSession) {
      var consulta = new Consulta();
      consulta.idUsuario = localStorage.getItem("paramId");
      consulta.token = localStorage.getItem("paramToken");
      consulta.restriciones = this.getCondiciones(param);
      console.log(consulta);
      let promesa = new Promise((resolve, reject) => {
        let url = URL_SERVICIOS + '/consultas/relizaConsultaFiltrosExcel';

        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, consulta, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            console.log(data);
            if (data.error) {
              resolve(false);
            } else {
              this.datosExcel = data.resultado;
              resolve(true);
            }

          })
      });
      return promesa;
    }
  }
  coincidencias: any[] = [];
  venta: any = {};
  detalle: any = {};


  getCondiciones(param: Filtro): any {
    var condicion = " where 1 = 1 ";

    //  Tipo pase 

    if (param.adulto) {
      condicion = condicion + " and tipo.id = 1";
    }
    if (param.nino) {
      condicion = condicion + " and tipo.id = 2";
    }

    //  Parques

    if (param.jardines) {
      condicion = condicion + " and empresa.id = 1 ";
    }
    if (param.hacienda) {
      condicion = condicion + " and empresa.id = 2 ";
    }
    if (param.estacas) {
      condicion = condicion + " and empresa.id = 3 ";
    }
    if (param.zoofari) {
      condicion = condicion + " and empresa.id = 4 ";
    }

    // Tipo busqueda
    if (param.texto != '') {
      if (param.tipoBusqueda == 1) {
        condicion = condicion + "and detalle.nombre like '" + param.texto + "%' ";
      }
      if (param.tipoBusqueda == 2) {
        condicion = condicion + "and usuario.correo = '" + param.texto + "' ";
      }
      if (param.tipoBusqueda == 3) {
        condicion = condicion + "and  detalle.id = " + param.texto + " ";
      }
      if (param.tipoBusqueda == 4) {
        condicion = condicion + "and venta.id = " + param.texto + " ";
      }
    }

    //  Fechas

    if (param.inicio != undefined && param.inicio != '') {
      condicion = condicion + " and detalle.fechaInicio >= '" + param.inicio + "' ";
    }
    if (param.fin != undefined && param.fin != '') {
      condicion = condicion + " and detalle.fechaInicio <=  '" + param.fin + "' ";
    }

    return condicion;
  }

  obtieneCoincidencias(param: Filtro): any {
    if (this.esNuevaSession) {
      var consulta = new Consulta();
      consulta.idUsuario = localStorage.getItem("paramId");
      consulta.token = localStorage.getItem("paramToken");
      consulta.restriciones = this.getCondiciones(param);
      console.log(consulta);
      let promesa = new Promise((resolve, reject) => {
        let url = URL_SERVICIOS + '/consultas/relizaConsultaFiltros';

        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, consulta, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            console.log(data);
            if (data.error) {
              resolve(false);
            } else {
              this.coincidencias = data.resultado;
              resolve(true);
            }

          })
      });
      return promesa;
    }
  }



  /**
 * Obtiene venta
 */
  obtieneVenta(idVenta: any) {
    if (this.esNuevaSession) {
      let promesa = new Promise((resolve, reject) => {
        let url = URL_SERVICIOS + '/consultas/datosDeVentaUsuario/' + idVenta;
        this.http.get(url)
          .map(resp => resp.json())
          .subscribe(data => {
            this.venta = data.resultado;
            console.info(this.venta);
            resolve(true);
          });
      });
      return promesa;
    }
  }


  /**
 * Obtiene detalle
 */
  obtieneDetalle(idDetalle: any) {
    if (this.esNuevaSession) {
      let promesa = new Promise((resolve, reject) => {
        let url = URL_SERVICIOS + '/consultas/datosDePaseUsuario/' + idDetalle;
        this.http.get(url)
          .map(resp => resp.json())
          .subscribe(data => {
            this.detalle = data.resultado;
            console.info(this.detalle);
            resolve(true);
          });
      });
      return promesa;
    }
  }


  /**
   * Actualiza el detalle de la venta
   * @param param 
   */
  actualizarVenta(param: Venta): any {
    if (this.esNuevaSession) {
      param.idUsuario = localStorage.getItem("paramId");
      param.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {

        console.log("Item to updtae")
        console.log(param);

        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/consultas/actualizaInformacionVenta';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, param, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            console.log(data);
            if (data.error) {
              resolve(false);
            } else {
              resolve(true);
            }
          })
      });
      return promesa;
    }
  }

  /**
   * Actualiza el detalle del pase
   * @param param 
   */
  actualizarDetalle(param: Detalle): any {
    if (this.esNuevaSession) {
      param.idUsuario = localStorage.getItem("paramId");
      param.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {

        console.log("Item to updtae")
        console.log(param);

        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/consultas/actualizaInformacionPase';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, param, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            console.log(data);
            if (data.error) {
              resolve(false);
            } else {
              resolve(true);
            }
          })
      });
      return promesa;
    }
  }

  entradasBlog: any = [];
  userSession: any;
  idBlog: any;
  idImg: any;
  rutaImagen: any = [];

  constructor(private router: Router, public http: Http) {
    //Activar en prod
    this.router.navigate(['/perfil']);
  }

  goLogin(): any {
    $("#btn_open_modal_perfiles").click();
    this.router.navigate(['/perfil']);
  }

  esNuevaSession(): any {
    var nueva = false;
    console.log(localStorage.getItem("paramId"));
    if (localStorage.getItem("paramId") == null || localStorage.getItem("paramId") == '') {
      nueva = true;
      console.log(nueva);
      this.goLogin();
    }
    console.log("Es nueva sesion " + nueva);
    return nueva;
  }

  cerrarSesion(): any {
    localStorage.removeItem("paramId");
    localStorage.removeItem("paramToken");
    localStorage.removeItem("perfil");
  }

  /**
   * Guarda una imagen en el servidor
   * @param paramImg
   */
  guardarImagen(paramImg: any) {
    if (this.esNuevaSession) {
      paramImg.idUsuario = localStorage.getItem("paramId");
      paramImg.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {

        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/files/subeImagen';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramImg, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            console.log(data);
            if (data.error) {
              resolve(false);
            } else {
              this.rutaImagen = data.rutaArchivo;
              resolve(true);
            }

          })
      });
      return promesa;
    }
  }

  /**
   * Guarda la ruta de la imagen adjuntada en tabla
   * @param imgTblParam
   */
  guardaImagenTabla(paramImgTbl: any): any {
    if (this.esNuevaSession) {
      paramImgTbl.idUsuario = localStorage.getItem("paramId");
      paramImgTbl.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/files/guardaImagenTabla';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramImgTbl, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            this.idImg = data.idFinal;
            resolve(true);
          })
      });
      return promesa;
    }
  }

  actualizaImagenTabla(paramImgTbl: any): any {
    console.log("imagen tabla");
    console.log(paramImgTbl);
    if (this.esNuevaSession) {
      paramImgTbl.idUsuario = localStorage.getItem("paramId");
      paramImgTbl.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/files/actualizaImagenTabla ';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramImgTbl, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            this.idImg = data.idFinal;
            resolve(true);
          })
      });
      return promesa;
    }
  }


  /**
   * Guarda la relacion de la imagen adjuntada y el blog
   *
   * @param paramRel
   */
  guardaRelacionImgBlog(paramRel: any): any {
    if (this.esNuevaSession) {
      paramRel.idUsuario = localStorage.getItem("paramId");
      paramRel.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/blog/guardaRelacionBlogImg';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramRel, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            resolve(true);
          })
      });
      return promesa;
    }
  }

  borraImagen(paramRuta: any): any {
    console.log("borraImagen");
    if (this.esNuevaSession) {
      var obj: any = {};
      obj.idUsuario = localStorage.getItem("paramId");
      obj.token = localStorage.getItem("paramToken");
      obj.ruta = paramRuta;
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/files/borraImagen ';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, obj, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            this.idBlog = data.idFinal;
            resolve(true);
          })
      });
      return promesa;
    }
  }

  /**
   * Guarda en BD el blog
   * @param blogParam
   */
  guardarBlog(paramBlog: any) {
    if (this.esNuevaSession) {
      paramBlog.idUsuario = localStorage.getItem("paramId");
      paramBlog.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/blog/guardaBlog';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramBlog, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            this.idBlog = data.idFinal;
            resolve(true);
          })
      });
      return promesa;
    }
  }

  /**
   * Valida las credenciales de acceso
   *
   * @param arg0
   */
  validarCredenciales(paramUser: any): any {

    let promesa = new Promise((resolve, reject) => {
      let data = new URLSearchParams();
      let url = URL_SERVICIOS + '/login/login';
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      this.http.post(url, paramUser, { headers })
        .map(resp => resp.json())
        .subscribe(data => {
          this.userSession = data;
         if(!this.userSession.error){
          localStorage.setItem("paramId", this.userSession.idUsuario);
          localStorage.setItem("paramToken", this.userSession.token);
          resolve(true);
         }
         else{
          resolve(false);
         }
         
         
        })
    });
    return promesa;
  }


  actualizaBlog(paramBlog: any) {
    if (this.esNuevaSession) {
      console.log("::: Blog actualizar service ");


      paramBlog.idUsuario = localStorage.getItem("paramId");
      paramBlog.token = localStorage.getItem("paramToken");

      console.log(paramBlog);
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/blog/actualizaBlog';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramBlog, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            console.log(data);
            resolve(true);
          })
      });
      return promesa;
    }
  }

  /**
  Eliminar Blog
  */
  eliminarBlog(paramBlog: any) {
    console.log("::: Blog eliminaBlog service ");
    if (this.esNuevaSession) {
      paramBlog.idUsuario = localStorage.getItem("paramId");
      paramBlog.token = localStorage.getItem("paramToken");

      //console.log(paramBlog);
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/blog/eliminarBlog';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramBlog, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            //console.log(data);
            resolve(true);
          })
      });
      return promesa;
    }
  }


  /**
   * Obtiene una lista de blogs
   */
  obtieneEntradasBlog() {
    if (this.esNuevaSession) {
      let promesa = new Promise((resolve, reject) => {
        let url = URL_SERVICIOS + '/blog/obtieneListaBlog';
        this.http.get(url)
          .map(resp => resp.json())
          .subscribe(data => {
            this.entradasBlog = data.resultado;
            console.info("::: ENTRADAS BLOG :::");
            console.info(this.entradasBlog);
            resolve(true);
          });
      });
      return promesa;
    }
  }

}//end class



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/services/consulta.service.ts